// extracted by mini-css-extract-plugin
export default {"page":"full-width-module__page___tYUet","page--headline":"full-width-module__page--headline___db8jf","no-padding":"full-width-module__no-padding___Ptot9"};